<template>
    <div class="content-wapper">
        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">知识产权综合服务</el-breadcrumb-item>
                    <el-breadcrumb-item>知识产权超市</el-breadcrumb-item>
                </el-breadcrumb>

                <!--
                <span>当前位置: &nbsp;&nbsp;</span>
                <span>知识产权综合服务 </span>
                <span>&nbsp; &gt; &nbsp;</span>
                <el-link :underline="false" @click="refresh" class="router" style="padding-bottom: 0.25rem"> 知识产权超市 </el-link>
                -->
            </el-col>
        </el-row>
        <div class="search-where">
            <div class="search-item">
                <div class="search-item-left">
                    技术领域：
                </div>
                <div class="search-item-right">
                    <el-button class="item-right-select-ly" :class="{'font-blue':'all'==queryParams.patentField}" @click="handlePatentField('all')">不限</el-button>
                    <el-button class="item-right-select-ly" v-for="item in fieldOptions" :class="{'font-blue':item.dictValue==queryParams.patentField}" @click="handlePatentField(item.dictValue)">
                        {{item.dictLabel}}
                    </el-button>
                </div>
            </div>
            <el-divider></el-divider>
            <div class="search-item">
                <div class="search-item-left">
                    专利类型：
                </div>
                <div class="search-item-right">
                    <el-button class="item-right-select-status" :class="{'font-blue':'all'==queryParams.patentType}" @click="handlePatentType('all')">不限</el-button>
                    <el-button class="item-right-select-status" v-for="item in typeOptions" :class="{'font-blue':item.dictValue==queryParams.patentType}" @click="handlePatentType(item.dictValue)">
                        {{item.dictLabel}}
                    </el-button>
                </div>
            </div>
            <el-divider></el-divider>
            <div class="search-item">
                <div class="search-item-left">
                    专利状态：
                </div>
                <div class="search-item-right">
                    <el-button class="item-right-select-status" :class="{'font-blue':'all'==queryParams.patentStatus}" @click="handlePatentStatus('all')">不限</el-button>
                    <el-button class="item-right-select-status" v-for="item in patentStatusOptions" :class="{'font-blue':item.dictValue==queryParams.patentStatus}" @click="handlePatentStatus(item.dictValue)">
                        {{item.dictLabel}}
                    </el-button>
                </div>
            </div>
            <el-divider></el-divider>
            <div class="search-item">
                <div class="search-item-left">
                    搜索查询：
                </div>
                <div class="search-item-right">
                    <el-input placeholder="请输入专利号/专利名称/摘要说明" v-model="queryParams.patentName" class="input-with-select" prefix-icon="el-icon-search">
                        <el-button slot="append" type="primary" @click="getList">搜索</el-button>
                    </el-input>
                </div>
                <div class="search-item-zr">
                    <el-button type="warning" class="button-zr" @click="openMarket">我要转让</el-button>
                </div>
            </div>
        </div>

        <div class="search-page">
            <div class="search-page-order">
                <el-button type="text" class="order-filed" :class="{'font-blue':queryParams.orderBy=='zhpx'}" @click="handleOrder('zhpx')">综合排序</el-button>
                <el-button type="text" class="order-filed" :class="{'font-blue':queryParams.orderBy=='fbsj'}" @click="handleOrder('fbsj')">
                    发布时间<i class="el-icon-bottom" v-if="queryParams.isAsc=='desc' && queryParams.orderBy=='fbsj'"></i>
                    <i class="el-icon-top" v-else></i>
                </el-button>
                <!--<el-button type="text" class="order-filed" :class="{'font-blue':queryParams.orderBy=='rd'}" @click="handleOrder('rd')">
                    热度<i class="el-icon-bottom" v-if="queryParams.isAsc=='desc' && queryParams.orderBy=='rd'"></i>
                    <i class="el-icon-top" v-else></i>
                </el-button>-->
            </div>
            <div class="search-page-page">
                <el-pagination class="pagination"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page.sync="queryParams.pageNum"
                               :page-size="queryParams.pageSize"
                               :hide-on-single-page="true"
                               layout="total, prev, pager, next"
                               :total="total"
                               @pagination="getList">
                </el-pagination>
            </div>
        </div>

        <div class="search-table">
            <el-table v-loading="loading" :data="list" :header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
                <el-table-column type="index" label="序号" align="center"></el-table-column>
                <el-table-column label="专利类型/专利号" header-align="center" align="center" prop="patentNo" :show-overflow-tooltip="true" width="260">
                  <template slot-scope="scope">
                       <el-row>
                          <el-col :span="6">
                            <el-tag type="success" effect="dark" v-if="scope.row.patentType=='syxx'">{{dictFormatType(scope.row.patentType)}}</el-tag>
                            <el-tag type="" effect="dark" v-else-if="scope.row.patentType=='fm'">{{dictFormatType(scope.row.patentType)}}</el-tag>
                            <el-tag type="warning" effect="dark" v-else-if="scope.row.patentType=='wgsj'">{{dictFormatType(scope.row.patentType)}}</el-tag>
                            <el-tag type="danger" effect="dark" v-else>{{dictFormatType(scope.row.patentType)}}</el-tag></el-col>
                           <el-col class="el-col-patentNo" :span="12"><span style="text-align: left;">{{scope.row.patentNo}}</span></el-col>
                       </el-row>
                    </template>
                </el-table-column>
                <el-table-column label="专利名称" header-align="center" align="center" prop="patentName" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-link :underline="false" @click="openDetail(scope.row.recid)">{{ scope.row.patentName }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="专利状态" align="center" prop="patentStatus" :width="150" >
                    <template slot-scope="scope">
                        <span class="font-success" v-if="scope.row.patentStatus=='yx'">{{dictFormatPatentStatus(scope.row.patentStatus)}}</span>
                        <span class="font-warning" v-else>{{dictFormatPatentStatus(scope.row.patentStatus)}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="发布日期" align="center" prop="fbDate" :width="150" />
                <el-table-column label="价格（元）" header-align="center" align="center" prop="patentPrice" :width="120" >
                    <template slot-scope="scope">
                        <span style="color:#999;" v-if="scope.row.patentPrice==null">询价</span>
                        <span class="font-danger" v-else>{{scope.row.patentPrice}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" header-align="center" align="center" class-name="small-padding fixed-width"
                                 :width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" icon="el-icon-download">下载说明书</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

    </div>
</template>

<script>
    import { listMarket } from "@/api/zscq/market";
    import {updatePvNum} from "@/api/itempv/pv";

    export default {
        name: "zscqcs",
        data() {
            return {
                // 遮罩层
                loading: true,
                // 总条数
                total: 0,
                // 表格数据
                list: [],
                // 查询参数
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    patentField:"all",
                    patentType:'all',
                    patentStatus:"all",
                    orderBy:"zhpx",
                    isAsc:"desc",
                    patentName:undefined
                },
                patentStatusOptions:[],
                typeOptions:[],
                fieldOptions:[],
                statusOptions:[]
            };
        },
        created() {
            this.getDicts("INDUSTRYPHY").then(response => {
                this.fieldOptions = response.data;
            });
            this.getDicts("patent_status").then(response => {
                this.patentStatusOptions = response.data;
            });
            this.getDicts("patent_type").then(response => {
                this.typeOptions = response.data;
            });
            /*this.getDicts("market_status").then(response => {
                this.statusOptions = response.data;
            });*/
            this.getList();
            updatePvNum("zscq_zscqcs").then(response => {
                //pv 点击知识产权超市
            });
        },
        methods: {
			refresh(){
			    this.getList();
			},
            getList(){
                this.list=[];
                this.loading = true;
                listMarket(this.queryParams).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.getList();
            },
            handlePatentField(code){
                this.queryParams.patentField=code;
                this.getList();
            },
            handlePatentType(code){
                this.queryParams.patentType=code;
                this.getList();
            },
            handlePatentStatus(code){
                this.queryParams.patentStatus=code;
                this.getList();
            },
            handleOrder(code){
                if(this.queryParams.orderBy==code){
                    //console.log(this.queryParams.isAsc);
                    if(this.queryParams.isAsc=="asc"){
                        this.queryParams.isAsc="desc";
                    }else{
                        this.queryParams.isAsc="asc";
                    }
                }
                if(code=="zhpx"){
                    this.queryParams.isAsc="asc";
                }
                this.queryParams.orderBy=code;
                this.getList();
            },
            openMarket(){
				this.$router.push({
				    path: '/main/zscqzhfw/zscqcsRecord'
				})
				this.$store.commit('SET_MAININDEX', '/main/zscqcs');
            },
            openDetail(recid){
                this.$router.push({
                    path: '/main/zscqzhfw/zscqcsDetail/'+recid
                })
                this.$store.commit('SET_MAININDEX', '/main/zscqcs');
            },
            dictFormatType(value) {
                return this.selectDictLabel(this.typeOptions, value) || '未知';
            },
            dictFormatPatentStatus(value) {
                return this.selectDictLabel(this.patentStatusOptions, value) || '未知';
            },
            dictFormatLabelType(row, column, cellValue) {
                if (cellValue == undefined) {
                    return '-';
                }
                let values = cellValue.split(",");
                let text = '';
                for (let value of values) {
                    text = text + "," + this.selectDictLabel(this.labelTypeOptions, value);
                }
                text = text.substring(1, text.length);
                return text == '' ? '-' : text;
            }
        }
    }
</script>

<style scoped>
    .content-wapper{
        margin-top: 5px;
        padding: 10px;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .search-where{
        margin: 10px 0px;
        padding: 15px;
        background-color: #ffffff;
    }
    .el-divider--horizontal{
        margin: 12px 0px;
    }
    .search-item{
        display: flex;
        /*border-bottom: 1px solid #000000;*/
    }
    .search-item-left{
        line-height: 40px;
        font-weight: bold;
    }
    .search-item-right{
        flex: 1;
        padding: 0px 10px;
    }
    .item-right-select-ly{
        float: left;
        /*width: 85px;*/
        padding: 5px 10px;
        line-height: 30px;
        /*border: 1px solid #000000;*/
    }
    .item-right-select-status{
        float: left;
        /*width: 110px;*/
        padding: 5px 20px;
        line-height: 30px;
    }
    .el-button{
        border: 0px;
    }
    .el-button+.el-button{
        margin-left: 0;
    }
    .el-input-group__append button.el-button{
        background-color:#4A8DEC;
        color: #ffffff;
    }
    /deep/.el-input--medium .el-input__inner{
        height: 40px;
        line-height: 40px;
    }
    .el-input-group__append .el-button--medium{
        padding: 13px 30px;
    }
    .search-item-zr{
        flex: 1;
        padding: 0px 100px 0px 0px;
        text-align: right;
    }
    .button-zr{
        height: 40px;
        line-height: 20px;
    }
    .search-page{
        margin: 0px 0px 10px;
        padding: 20px 15px;
        background-color: #ffffff;
        display: flex;
    }
    .search-page-order{
        display: flex;

    }
    .order-filed{
        flex: 1;
        padding: 0px 15px;
        color:#000000;
    }
    .search-page-page{
        flex: 1;
        text-align: right;
    }
    .search-table{
        margin: 0px;
        padding: 15px;
        background-color: #ffffff;
    }

    .danger-light {
        background-color: #F56C6C;
        padding: 5px 10px;
    }

    .warning-light {
        background-color: #E6A23C;
        padding: 5px 10px;
    }

    .success-light {
        background-color: #67C23A;
        padding: 5px 10px;
    }
    .font-success{
        color: #67C23A;
    }
    .font-danger{
        color: #F56C6C;
    }
    .font-warning{
        color: #e6a23c;
    }
    .font-blue{
        color: #409eff;
    }
    .search-item-right /deep/.el-button {
        background-color: #ffffff;
    }
    .el-col-patentNo{
        text-align: left;
        padding-top: 3px
    }
</style>
